/* ==========================================================================
   FASHION IN — prototype behaviour

   No framework, no build step. Each block below maps to one Shopify theme
   section's script, so this ports across without a rewrite.
   ========================================================================== */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, o) { if (el) { el.addEventListener(ev, fn, o); } };

  var EGP = function (n) {
    return 'EGP ' + Number(n).toLocaleString('en-US');
  };

  /* =======================================================================
     Scroll reveal
     ======================================================================= */
  (function reveal() {
    var targets = $$('[data-reveal], [data-reveal-group]');
    if (!targets.length) { return; }

    if (reduce.matches || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });
  })();

  /* =======================================================================
     Counting stats (Our Story)
     ======================================================================= */
  (function counters() {
    var nums = $$('[data-count]');
    if (!nums.length || reduce.matches || !('IntersectionObserver' in window)) { return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) { return; }
        io.unobserve(e.target);
        var el = e.target;
        var target = parseInt(el.dataset.count, 10);
        var suffix = el.dataset.suffix || '';
        var dur = 1100;
        var t0 = performance.now();
        (function tick(now) {
          var p = Math.min(1, (now - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) { requestAnimationFrame(tick); }
        })(t0);
      });
    }, { threshold: 0.5 });

    nums.forEach(function (el) { io.observe(el); });
  })();

  /* =======================================================================
     Sticky header
     ======================================================================= */
  (function header() {
    var el = $('[data-header]');
    if (!el) { return; }
    var f = function () { el.classList.toggle('is-stuck', window.scrollY > 8); };
    f();
    on(window, 'scroll', f, { passive: true });
  })();

  /* =======================================================================
     Announcement bar — rotates on small screens only
     ======================================================================= */
  (function announcement() {
    var wrap = $('[data-announcement]');
    if (!wrap) { return; }
    var items = $$('.announcement__item', wrap);
    if (items.length < 2) { return; }

    var mq = window.matchMedia('(min-width: 64rem)');
    var i = 0, timer = null;

    function show(n) { items.forEach(function (el, k) { el.classList.toggle('is-active', k === n); }); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (mq.matches || reduce.matches) { return; }
      timer = setInterval(function () { i = (i + 1) % items.length; show(i); }, 4200);
    }
    function sync() {
      if (mq.matches) { items.forEach(function (el) { el.classList.add('is-active'); }); stop(); }
      else { i = 0; show(0); start(); }
    }
    sync();
    mq.addEventListener('change', sync);
  })();

  /* =======================================================================
     Mega menu
     ======================================================================= */
  var openMenu = null;

  function setMenu(name, open) {
    var t = $('[data-menu="' + name + '"]');
    var p = $('[data-menu-panel="' + name + '"]');
    if (!t || !p) { return; }
    if (open) { p.hidden = false; requestAnimationFrame(function () { p.dataset.open = 'true'; }); }
    else { p.dataset.open = 'false'; }
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    openMenu = open ? name : (openMenu === name ? null : openMenu);
  }
  function closeMenus() {
    $$('[data-menu]').forEach(function (t) { setMenu(t.dataset.menu, false); });
    openMenu = null;
  }

  (function megamenu() {
    var closeTimer = null;
    var canHover = window.matchMedia('(hover: hover)');

    $$('[data-menu]').forEach(function (trigger) {
      var name = trigger.dataset.menu;
      var panel = $('[data-menu-panel="' + name + '"]');

      on(trigger, 'click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeMenus();
        if (!isOpen) { setMenu(name, true); }
      });

      [trigger, panel].forEach(function (el) {
        on(el, 'mouseenter', function () {
          if (!canHover.matches) { return; }
          clearTimeout(closeTimer);
          if (openMenu && openMenu !== name) { closeMenus(); }
          setMenu(name, true);
        });
        on(el, 'mouseleave', function () {
          if (!canHover.matches) { return; }
          closeTimer = setTimeout(function () { setMenu(name, false); }, 180);
        });
      });
    });

    on(document, 'click', function (e) {
      if (openMenu && !e.target.closest('[data-menu-panel]') && !e.target.closest('[data-menu]')) {
        closeMenus();
      }
    });
  })();

  /* =======================================================================
     Search panel
     ======================================================================= */
  /* IDs prefixed fi- to avoid colliding with Shopify's own theme markup;
     matches the real ids in sections/fi-header.liquid, not the prototype's. */
  var searchPanel = $('#fi-search-panel') || $('#search-panel');
  var searchToggle = $('[data-search-toggle]');

  function setSearch(open) {
    if (!searchPanel || !searchToggle) { return; }
    searchPanel.dataset.open = open ? 'true' : 'false';
    searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { closeMenus(); setTimeout(function () { var q = $('#fi-q') || $('#q'); if (q) { q.focus(); } }, 20); }
    else { searchToggle.focus(); }
  }
  on(searchToggle, 'click', function () { setSearch(searchPanel.dataset.open !== 'true'); });
  on($('[data-search-close]'), 'click', function () { setSearch(false); });

  /* =======================================================================
     Panels: mobile drawer + cart drawer (shared overlay and focus handling)
     ======================================================================= */
  var overlay = $('[data-overlay]');
  var drawer = $('[data-drawer]');
  var cartDrawer = $('[data-cart-drawer]');
  var lastFocus = null;

  function anyPanelOpen() {
    return (drawer && drawer.dataset.open === 'true') ||
           (cartDrawer && cartDrawer.dataset.open === 'true');
  }

  function setPanel(panel, open) {
    if (!panel) { return; }
    panel.dataset.open = open ? 'true' : 'false';
    if (overlay) { overlay.dataset.open = anyPanelOpen() ? 'true' : 'false'; }
    document.body.style.overflow = anyPanelOpen() ? 'hidden' : '';

    if (open) {
      lastFocus = document.activeElement;
      var first = panel.querySelector('a, button, input');
      if (first) { first.focus(); }
    } else if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  on($('[data-drawer-open]'), 'click', function () {
    setPanel(drawer, true);
    var b = $('[data-drawer-open]');
    if (b) { b.setAttribute('aria-expanded', 'true'); }
  });
  on($('[data-drawer-close]'), 'click', function () {
    setPanel(drawer, false);
    var b = $('[data-drawer-open]');
    if (b) { b.setAttribute('aria-expanded', 'false'); }
  });
  on($('[data-cart-open]'), 'click', function () { setPanel(cartDrawer, true); });
  on($('[data-cart-close]'), 'click', function () { setPanel(cartDrawer, false); });
  on(overlay, 'click', function () {
    setPanel(drawer, false);
    setPanel(cartDrawer, false);
    var b = $('[data-drawer-open]');
    if (b) { b.setAttribute('aria-expanded', 'false'); }
  });

  on(document, 'keydown', function (e) {
    if (e.key === 'Escape') {
      if (cartDrawer && cartDrawer.dataset.open === 'true') { setPanel(cartDrawer, false); return; }
      if (drawer && drawer.dataset.open === 'true') {
        setPanel(drawer, false);
        var b = $('[data-drawer-open]');
        if (b) { b.setAttribute('aria-expanded', 'false'); }
        return;
      }
      if (searchPanel && searchPanel.dataset.open === 'true') { setSearch(false); return; }
      if (openMenu) { var t = $('[data-menu="' + openMenu + '"]'); closeMenus(); if (t) { t.focus(); } }
      return;
    }

    if (e.key !== 'Tab') { return; }
    var panel = (cartDrawer && cartDrawer.dataset.open === 'true') ? cartDrawer
              : (drawer && drawer.dataset.open === 'true') ? drawer : null;
    if (!panel) { return; }
    var f = $$('a[href], button:not([disabled]), input, textarea, select', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) { return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Drawer accordions
  $$('.drawer__toggle').forEach(function (btn) {
    on(btn, 'click', function () {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) { panel.dataset.open = open ? 'false' : 'true'; }
    });
  });

  /* =======================================================================
     Hero carousel
     ======================================================================= */
  (function hero() {
    var root = $('[data-hero]');
    if (!root) { return; }
    var slides = $$('.hero__slide', root);
    var dotsWrap = $('[data-hero-dots]');
    var current = 0, autoplay = null;

    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'hero__dot';
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      on(d, 'click', function () { go(i); restart(); });
      dotsWrap.appendChild(d);
    });
    var dots = $$('.hero__dot', dotsWrap);

    function go(n) {
      current = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var active = i === current;
        s.classList.toggle('is-active', active);
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    }
    function restart() {
      if (autoplay) { clearInterval(autoplay); autoplay = null; }
      if (reduce.matches || slides.length < 2) { return; }
      autoplay = setInterval(function () { go(current + 1); }, 6500);
    }

    on($('[data-hero-prev]'), 'click', function () { go(current - 1); restart(); });
    on($('[data-hero-next]'), 'click', function () { go(current + 1); restart(); });

    var heroEl = $('.hero');
    ['mouseenter', 'focusin'].forEach(function (ev) {
      on(heroEl, ev, function () { if (autoplay) { clearInterval(autoplay); autoplay = null; } });
    });
    ['mouseleave', 'focusout'].forEach(function (ev) {
      on(heroEl, ev, function () { if (!autoplay) { restart(); } });
    });

    var x0 = null;
    on(root, 'touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    on(root, 'touchend', function (e) {
      if (x0 === null) { return; }
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { go(dx < 0 ? current + 1 : current - 1); restart(); }
      x0 = null;
    }, { passive: true });

    go(0);
    restart();
  })();

  /* =======================================================================
     Product rails (scroll-snap on small screens)
     ======================================================================= */
  $$('[data-rail]').forEach(function (rail) {
    var track = $('[data-rail-track]', rail);
    var dotsWrap = $('[data-rail-dots]', rail);
    if (!track) { return; }
    var cards = $$(':scope > *', track);
    if (!cards.length) { return; }

    cards.forEach(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'rail__dot';
      d.setAttribute('aria-label', 'Go to item ' + (i + 1));
      d.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      on(d, 'click', function () { scrollToCard(i); });
      if (dotsWrap) { dotsWrap.appendChild(d); }
    });
    var dots = dotsWrap ? $$('.rail__dot', dotsWrap) : [];

    function scrollToCard(i) {
      var c = cards[i];
      if (c) { track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: reduce.matches ? 'auto' : 'smooth' }); }
    }
    function nearest() {
      var best = 0, min = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }
    on(track, 'scroll', function () {
      var i = nearest();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }, { passive: true });

    function step(dir) {
      var i = nearest() + dir;
      if (i < 0) { i = cards.length - 1; }
      if (i > cards.length - 1) { i = 0; }
      scrollToCard(i);
    }
    on($('[data-rail-prev]', rail), 'click', function () { step(-1); restartAutoplay(); });
    on($('[data-rail-next]', rail), 'click', function () { step(1); restartAutoplay(); });

    /* Cycles through every product in the collection, one card every 30s,
       not just the 4 visible at a time — the section pulls more products
       than fit on screen specifically so this has something to reveal. */
    var railTimer = null;
    function startAutoplay() {
      if (reduce.matches || cards.length < 2) { return; }
      railTimer = setInterval(function () { step(1); }, 30000);
    }
    function stopAutoplay() { if (railTimer) { clearInterval(railTimer); railTimer = null; } }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    on(rail, 'mouseenter', stopAutoplay);
    on(rail, 'mouseleave', startAutoplay);
    on(rail, 'focusin', stopAutoplay);
    on(rail, 'focusout', startAutoplay);
    on(track, 'touchstart', stopAutoplay, { passive: true });

    startAutoplay();
  });

  /* =======================================================================
     Cart — persisted in localStorage so the prototype behaves like a store
     ======================================================================= */
  var FREE_SHIPPING = 2500;
  var CATALOGUE = {};
  $$('[data-add]').forEach(function (b) {
    var card = b.closest('.product-card') || b.closest('.pdp__info') || document;
    var slug = b.dataset.add;
    if (CATALOGUE[slug]) { return; }
    var titleEl = $('.product-card__title a', card) || $('.pdp__title', card);
    var priceEl = $('.product-card__price', card) || $('.pdp__price', card);
    var imgEl = $('.product-card__media img', card) || $('.pdp__stage img', card);
    var price = 0;
    if (priceEl) {
      var m = priceEl.textContent.replace(/,/g, '').match(/(\d+)\s*$/);
      price = m ? parseInt(m[1], 10) : 0;
    }
    CATALOGUE[slug] = {
      slug: slug,
      title: titleEl ? titleEl.textContent.trim() : slug,
      price: price,
      img: imgEl ? imgEl.getAttribute('src') : ''
    };
  });

  function readCart() {
    try { return JSON.parse(localStorage.getItem('fi_cart') || '[]'); }
    catch (e) { return []; }
  }
  function writeCart(items) {
    try { localStorage.setItem('fi_cart', JSON.stringify(items)); } catch (e) {}
    renderCart(items);
  }
  function cartCount(items) {
    return items.reduce(function (n, i) { return n + i.qty; }, 0);
  }
  function cartTotal(items) {
    return items.reduce(function (n, i) { return n + i.price * i.qty; }, 0);
  }

  function renderCart(items) {
    items = items || readCart();
    var count = cartCount(items);
    var total = cartTotal(items);

    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    $$('[data-cart-total]').forEach(function (el) { el.innerHTML = EGP(total); });

    // free-shipping progress
    var bar = $('[data-ship-bar]');
    if (bar) {
      var fill = $('[data-ship-fill]', bar);
      var text = $('[data-ship-text]', bar);
      var pct = Math.min(100, (total / FREE_SHIPPING) * 100);
      if (fill) { fill.style.width = pct + '%'; }
      if (text) {
        text.innerHTML = total >= FREE_SHIPPING
          ? 'Your order ships <strong>free</strong>.'
          : 'Spend <strong>' + EGP(FREE_SHIPPING - total) + '</strong> more for free shipping.';
      }
    }

    // drawer lines
    var wrap = $('[data-cart-lines]');
    if (!wrap) { return; }
    var empty = $('[data-cart-empty]', wrap);
    $$('.cart-line', wrap).forEach(function (el) { el.remove(); });

    if (!items.length) { if (empty) { empty.hidden = false; } return; }
    if (empty) { empty.hidden = true; }

    items.forEach(function (it) {
      var line = document.createElement('div');
      line.className = 'cart-line';
      line.innerHTML =
        '<a class="cart-line__media" href="product.html?p=' + it.slug + '">' +
          '<img src="' + it.img + '" alt="" width="720" height="960" loading="lazy"></a>' +
        '<div>' +
          '<a class="cart-line__title" href="product.html?p=' + it.slug + '">' + it.title + '</a>' +
          (it.size ? '<p class="cart-line__opt">Size: ' + it.size + '</p>' : '') +
          '<div class="cart-line__mobile-row">' +
            '<p class="cart-line__price">' + EGP(it.price) + '</p>' +
            '<div class="qty">' +
              '<button type="button" data-drawer-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" value="' + it.qty + '" min="1" max="10" readonly aria-label="Quantity">' +
              '<button type="button" data-drawer-qty="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button class="cart-line__remove" type="button" data-drawer-remove aria-label="Remove ' + it.title + '">' +
              '<svg aria-hidden="true"><use href="#i-trash"/></svg></button>' +
          '</div>' +
        '</div>';
      line.dataset.slug = it.slug;
      wrap.appendChild(line);
    });
  }

  function addToCart(slug, size, qty) {
    var base = CATALOGUE[slug];
    if (!base) { return; }
    var items = readCart();
    var found = items.filter(function (i) { return i.slug === slug && i.size === size; })[0];
    if (found) { found.qty = Math.min(10, found.qty + qty); }
    else { items.push({ slug: slug, title: base.title, price: base.price, img: base.img, size: size, qty: qty }); }
    writeCart(items);

    var bag = $('.icon-btn--cart');
    if (bag && !reduce.matches) {
      bag.classList.remove('is-bumped');
      void bag.offsetWidth;
      bag.classList.add('is-bumped');
    }
    toast(base.title + ' added to your cart');
  }

  on(document, 'click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      var slug = add.dataset.add;
      var size = null, qty = 1;
      var info = add.closest('.pdp__info');
      if (info) {
        var sizeBtn = $('[data-size] [aria-pressed="true"]', info);
        size = sizeBtn ? sizeBtn.textContent.trim() : null;
        var qi = $('[data-qty-input]', info);
        qty = qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
      }
      addToCart(slug, size, qty);
      return;
    }

    var dq = e.target.closest('[data-drawer-qty]');
    if (dq) {
      var lineEl = dq.closest('.cart-line');
      var items = readCart();
      var it = items.filter(function (i) { return i.slug === lineEl.dataset.slug; })[0];
      if (it) {
        it.qty = Math.min(10, Math.max(1, it.qty + parseInt(dq.dataset.drawerQty, 10)));
        writeCart(items);
      }
      return;
    }

    var dr = e.target.closest('[data-drawer-remove]');
    if (dr) {
      var l = dr.closest('.cart-line');
      writeCart(readCart().filter(function (i) { return i.slug !== l.dataset.slug; }));
      return;
    }

    var wish = e.target.closest('[data-wish]');
    if (wish) {
      var pressed = wish.getAttribute('aria-pressed') === 'true';
      wish.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      var n = $$('[data-wish][aria-pressed="true"]').length;
      $$('[data-wish-count]').forEach(function (el) { el.textContent = n; });
      toast(pressed ? 'Removed from wishlist' : 'Saved to your wishlist');
    }
  });

  // Only the static prototype's own drawer/cart-page markup should be driven
  // by this fake localStorage cart. On the real Shopify theme neither
  // container exists (the header badge is server-rendered from the real
  // `cart.item_count` instead) — without this guard, renderCart() would
  // unconditionally overwrite that correct count with the fake cart's count
  // (almost always 0) on every real page load.
  if ($('[data-cart-lines]') || $('[data-cart-page]')) { renderCart(); }

  /* =======================================================================
     Toast
     ======================================================================= */
  var toastTimer = null;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) { return; }
    var txt = $('[data-toast-text]', el);
    if (txt) { txt.textContent = msg; }
    el.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.dataset.open = 'false'; }, 3200);
  }

  /* =======================================================================
     Cart page — quantity, totals, remove
     ======================================================================= */
  (function cartPage() {
    var page = $('[data-cart-page]');
    if (!page) { return; }

    // The page is server-rendered with demo line items so it reads correctly
    // with JS disabled. On load we harvest that DOM into the same
    // localStorage cart the header badge and drawer read from, so all three
    // agree — otherwise the page shows 3 items while the header badge (fed
    // from an empty localStorage cart) shows 0.
    function harvestAndSync() {
      var items = $$('.cart-line[data-line]', page).map(function (line) {
        var input = $('[data-line-input]', line);
        var img = $('.cart-line__media img', line);
        var title = $('.cart-line__title', line);
        return {
          slug: line.dataset.line,
          size: line.dataset.size || null,
          title: title ? title.textContent.trim() : line.dataset.line,
          price: input ? parseInt(input.dataset.price, 10) : 0,
          img: img ? img.getAttribute('src') : '',
          qty: input ? Math.max(1, parseInt(input.value, 10) || 1) : 1
        };
      });
      writeCart(items);
    }

    function recalc() {
      var sub = 0, count = 0;
      $$('.cart-line', page).forEach(function (line) {
        var input = $('[data-line-input]', line);
        if (!input) { return; }
        var qty = Math.max(1, parseInt(input.value, 10) || 1);
        var price = parseInt(input.dataset.price, 10);
        var total = qty * price;
        sub += total;
        count += qty;
        var tEl = $('[data-line-total]', line);
        if (tEl) { tEl.innerHTML = EGP(total); }
      });
      $$('[data-subtotal]').forEach(function (el) { el.innerHTML = EGP(sub); });
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      harvestAndSync();
    }

    harvestAndSync();

    on(page, 'click', function (e) {
      var q = e.target.closest('[data-line-qty]');
      if (q) {
        var input = $('[data-line-input]', q.closest('.cart-line'));
        input.value = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.lineQty, 10)));
        recalc();
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) {
        var line = rm.closest('.cart-line');
        line.style.transition = 'opacity 220ms, transform 220ms';
        line.style.opacity = '0';
        line.style.transform = 'translateX(-12px)';
        setTimeout(function () {
          line.remove();
          recalc();
          if (!$$('.cart-line', page).length) {
            page.innerHTML = '<div class="empty-state">' +
              '<svg aria-hidden="true"><use href="#i-bag"/></svg>' +
              '<h3>Your cart is empty</h3>' +
              '<p>Nothing here yet &mdash; the new arrivals are a good place to start.</p>' +
              '<a class="btn btn--primary" href="collection.html?sort=new">Shop new arrivals</a></div>';
          }
        }, reduce.matches ? 0 : 220);
      }
    });

    on(page, 'input', function (e) { if (e.target.matches('[data-line-input]')) { recalc(); } });

    var note = $('.cart-note__head', page);
    on(note, 'click', function () {
      var ta = $('#order-note');
      var open = note.getAttribute('aria-expanded') === 'true';
      note.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (ta) { ta.hidden = open; if (!open) { ta.focus(); } }
    });
  })();

  // Discount toggle
  (function discount() {
    var btn = $('.discount__toggle');
    if (!btn) { return; }
    on(btn, 'click', function () {
      var form = $('#disc-form');
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (form) { form.hidden = open; if (!open) { $('#disc').focus(); } }
    });
  })();

  /* =======================================================================
     Product page — gallery, options, quantity, accordion
     ======================================================================= */
  (function pdp() {
    var gallery = $('[data-gallery]');
    if (gallery) {
      var thumbs = $$('[data-thumb]', gallery);
      var stages = $$('[data-stage]', gallery);
      thumbs.forEach(function (t) {
        on(t, 'click', function () {
          var i = parseInt(t.dataset.thumb, 10);
          thumbs.forEach(function (x, k) { x.setAttribute('aria-current', k === i ? 'true' : 'false'); });
          stages.forEach(function (s, k) { s.hidden = k !== i; });
        });
      });
    }

    $$('[data-size] .size-btn').forEach(function (b) {
      on(b, 'click', function () {
        $$('[data-size] .size-btn').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });

    $$('[data-colour] .swatch-btn').forEach(function (b) {
      on(b, 'click', function () {
        $$('[data-colour] .swatch-btn').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        var name = $('[data-colour-name]');
        if (name) { name.textContent = b.getAttribute('title'); }
      });
    });

    $$('[data-qty]').forEach(function (b) {
      on(b, 'click', function () {
        var input = $('[data-qty-input]');
        if (!input) { return; }
        input.value = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
      });
    });

    $$('.accordion__head').forEach(function (h) {
      on(h, 'click', function () {
        var body = document.getElementById(h.getAttribute('aria-controls'));
        var open = h.getAttribute('aria-expanded') === 'true';
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) { body.hidden = open; }
      });
    });
  })();

  /* =======================================================================
     Product page — real Shopify variant selection + AJAX add to cart.
     Every option is a real <button data-option-value> inside a
     [data-option-index] group; a JSON island (rendered by fi-product.liquid)
     lists each real variant's id/price/availability/image so a click can
     resolve the matching variant without a page reload. The button clicks
     above already toggle aria-pressed generically — this only adds variant
     resolution on top, and works even if that JSON island is absent (no-op).
     ======================================================================= */
  (function pdpVariants() {
    var form = document.getElementById('fi-product-form');
    var data = $('[data-pdp-variants]');
    if (!form || !data) { return; }

    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }

    var groups = $$('[data-option-index]', form);
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]');
    var addBtn = $('[data-add-to-cart]', form);
    var addLabel = addBtn ? $('[data-add-label]', addBtn) : null;

    function selected() {
      return groups.map(function (g) {
        var pressed = $('[aria-pressed="true"]', g);
        return pressed ? pressed.dataset.optionValue : null;
      });
    }

    function matchVariant() {
      var sel = selected();
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; });
      })[0];
    }

    function applyVariant(v) {
      if (!v) { return; }
      if (idInput) { idInput.value = v.id; }
      if (priceEl) {
        priceEl.innerHTML = v.compare_at_price ? ('<del>' + v.compare_at_price + '</del> ' + v.price) : v.price;
      }
      if (addBtn) { addBtn.disabled = !v.available; }
      if (addLabel) { addLabel.textContent = v.available ? 'Add to bag' : 'Sold out'; }
      if (v.featured_image) {
        var mainImg = $('.pdp__stage img:not([hidden])') || $('.pdp__stage img');
        if (mainImg) { mainImg.src = v.featured_image; }
      }
    }

    groups.forEach(function (g) {
      $$('.size-btn, .swatch-btn', g).forEach(function (b) {
        on(b, 'click', function () { applyVariant(matchVariant()); });
      });
    });
  })();

  /* =======================================================================
     Add to cart — AJAX-enhances any real Shopify product form (the PDP's
     #fi-product-form and each product card's quick-add form), falling back
     to a normal form POST (which Shopify handles fine on its own) if fetch
     is unavailable.
     ======================================================================= */
  (function addToCartAjax() {
    if (!window.fetch) { return; }

    on(document, 'submit', function (e) {
      var form = e.target.closest('#fi-product-form, .product-card__quick-form');
      if (!form) { return; }
      e.preventDefault();

      var addBtn = $('[data-add-to-cart]', form) || $('button[type="submit"]', form);
      var addLabel = addBtn ? $('[data-add-label]', addBtn) : null;
      var prevLabel = addLabel ? addLabel.textContent : (addBtn ? addBtn.textContent : '');
      if (addBtn) { addBtn.disabled = true; }
      if (addLabel) { addLabel.textContent = 'Adding…'; }

      fetch(form.action || '/cart/add', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'application/json' }
      }).then(function (r) { return r.json(); }).then(function (json) {
        if (json.status) {
          toast(json.description || json.message || 'Could not add this item to your cart.');
        } else {
          toast((json.title || json.product_title || 'Item') + ' added to your cart');
          var bag = $('.icon-btn--cart');
          if (bag && !reduce.matches) {
            bag.classList.remove('is-bumped');
            void bag.offsetWidth;
            bag.classList.add('is-bumped');
          }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});
        }
      }).catch(function () {
        toast('Something went wrong — please try again.');
      }).then(function () {
        if (addBtn) { addBtn.disabled = false; }
        if (addLabel) { addLabel.textContent = prevLabel; }
      });
    });
  })();

  /* =======================================================================
     Cart page — real Shopify cart via AJAX. Every control here is a real
     <input>/<a> first (quantity inputs post as updates[], remove links use
     Shopify's own item.url_to_remove), so the page still works with JS off;
     this only makes it feel instant when JS is available. Scoped to
     [data-cart-real] specifically so it never runs against the static
     prototype's fake-cart page above.
     ======================================================================= */
  (function cartPageReal() {
    var page = $('[data-cart-real]');
    if (!page || !window.fetch) { return; }
    var FREE_SHIPPING = 2500;

    function renderTotals(cart) {
      $$('[data-subtotal]').forEach(function (el) { el.innerHTML = EGP(cart.total_price / 100); });
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var bar = $('[data-ship-bar]');
      if (bar) {
        var fill = $('[data-ship-fill]', bar);
        var text = $('[data-ship-text]', bar);
        var total = cart.total_price / 100;
        var pct = Math.min(100, (total / FREE_SHIPPING) * 100);
        if (fill) { fill.style.width = pct + '%'; }
        if (text) {
          text.innerHTML = total >= FREE_SHIPPING
            ? 'Your order ships <strong>free</strong>.'
            : 'Spend <strong>' + EGP(FREE_SHIPPING - total) + '</strong> more for free shipping.';
        }
      }
    }

    function changeLine(key, quantity, lineEl) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function (cart) {
        renderTotals(cart);
        if (quantity === 0) {
          lineEl.style.transition = 'opacity 220ms, transform 220ms';
          lineEl.style.opacity = '0';
          lineEl.style.transform = 'translateX(-12px)';
          setTimeout(function () {
            lineEl.remove();
            if (!cart.item_count) { location.reload(); }
          }, reduce.matches ? 0 : 220);
          return;
        }
        var item = cart.items.filter(function (i) { return i.key === key; })[0];
        if (item) {
          var tEl = $('[data-line-total]', lineEl);
          if (tEl) { tEl.innerHTML = EGP(item.final_line_price / 100); }
          var input = $('[data-line-input]', lineEl);
          if (input) { input.value = item.quantity; }
        }
      }).catch(function () { location.reload(); });
    }

    on(page, 'click', function (e) {
      var q = e.target.closest('[data-line-qty]');
      if (q) {
        e.preventDefault();
        var lineEl = q.closest('.cart-line');
        var input = $('[data-line-input]', lineEl);
        var next = Math.min(10, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(q.dataset.lineQty, 10)));
        changeLine(lineEl.dataset.key, next, lineEl);
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) {
        e.preventDefault();
        var line = rm.closest('.cart-line');
        changeLine(line.dataset.key, 0, line);
      }
    });

    var note = $('.cart-note__head', page);
    on(note, 'click', function () {
      var ta = $('#order-note');
      var open = note.getAttribute('aria-expanded') === 'true';
      note.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (ta) { ta.hidden = open; if (!open) { ta.focus(); } }
    });
  })();

  /* =======================================================================
     Collection page — filters and sort
     ======================================================================= */
  (function collection() {
    var grid = $('[data-product-grid]');
    if (!grid) { return; }

    var cards = $$('.product-card', grid);
    var empty = $('[data-grid-empty]');
    var countEl = $('[data-result-count]');

    // Index each card so filtering does not re-read the DOM every keystroke
    var index = cards.map(function (card) {
      var priceText = $('.product-card__price', card).textContent.replace(/,/g, '');
      var nums = priceText.match(/\d+/g) || ['0'];
      return {
        el: card,
        price: parseInt(nums[nums.length - 1], 10),
        sale: !!$('.product-card__badge--sale', card),
        out: !!$('.product-card__badge--out', card),
        title: $('.product-card__title', card).textContent.toLowerCase()
      };
    });

    function apply() {
      var checkedCats = $$('input[name="cat"]:checked').map(function (i) { return i.value; });
      var avail = $$('input[name="avail"]:checked').map(function (i) { return i.value; });
      var shown = 0;

      index.forEach(function (item) {
        var ok = true;
        if (avail.indexOf('in') > -1 && item.out) { ok = false; }
        if (avail.indexOf('sale') > -1 && !item.sale) { ok = false; }
        item.el.hidden = !ok;
        if (ok) { shown++; }
      });

      if (countEl) { countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces'); }
      if (empty) { empty.hidden = shown > 0; }
      grid.hidden = shown === 0;
      // category filters are visual-only here; real filtering happens in Liquid
      void checkedCats;
    }

    $$('input[name="cat"], input[name="size"], input[name="avail"]').forEach(function (i) {
      on(i, 'change', apply);
    });

    $$('.swatch-btn').forEach(function (b) {
      on(b, 'click', function () {
        b.setAttribute('aria-pressed', b.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      });
    });

    on($('[data-clear-filters]'), 'click', function () {
      $$('input[name="cat"], input[name="size"], input[name="avail"]').forEach(function (i) { i.checked = false; });
      $$('.swatch-btn').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      apply();
    });

    on($('[data-sort]'), 'change', function (e) {
      var v = e.target.value;
      var sorted = index.slice();
      if (v === 'price-asc') { sorted.sort(function (a, b) { return a.price - b.price; }); }
      else if (v === 'price-desc') { sorted.sort(function (a, b) { return b.price - a.price; }); }
      else if (v === 'new') { sorted.reverse(); }
      sorted.forEach(function (item) { grid.appendChild(item.el); });
    });

    var toggle = $('[data-filter-toggle]');
    on(toggle, 'click', function () {
      var f = $('[data-filters]');
      var open = f.dataset.open === 'true';
      f.dataset.open = open ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });

    $$('.filter-group__head').forEach(function (h) {
      on(h, 'click', function () {
        var body = document.getElementById(h.getAttribute('aria-controls'));
        var open = h.getAttribute('aria-expanded') === 'true';
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) { body.hidden = open; }
      });
    });
  })();

})();
